import { useLocation, useNavigate } from 'react-router-dom';
import { AiOutlineZoomIn, AiOutlineZoomOut } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCommentData,
  addNote,
  setActiveEntityId,
  toggleNoteMode,
  selectIsNotMode,
  clearNotes,
} from '../../redux/notesetting/notesSettingsSlice';
import { Button, Col, Row, Segmented, Spin, Tooltip } from 'antd';
import UilCommentAlt from '@iconscout/react-unicons/icons/uil-comment-alt';
import '../../static/css/Notes.css';
import { showNotification, MessageType } from '../common/CommonStyle';
import { useEffect, useState } from 'react';
import { get, post } from '../../config/dataService/dataService';
import Page from './Page';
import { Cards } from '../../components/cards/frame/cards-frame';
import { ActivityContents } from '../../container/profile/myProfile/overview/Style';
import { RollbackOutlined } from '@ant-design/icons';
import { PageHeader } from '../../components/page-headers/page-headers';
import moment from 'moment';
import { Main } from '../../container/styled';
import { DataTableStyleWrap } from '../../components/table/Style';
import Checklist from '../../container/checklist/Checklist';

const GetReviewImage = () => {
  const urls = {
    getcommentByImageid: 'ProofComment/GetCommentsByProofId',
    updateClassApproval: 'Proof/Updateclassapproval',
  };
  const approvalEnums = {
    Reject: 0,
    Approved: 1,
    Pending: 2,
    ApprovedWithComments: 3,
  };
  const location = useLocation();
  const { imageData, isFromProofPage, proofId, workflowContactId } = location.state || {};
  const dispatch = useDispatch();
  const [showApprove, setShowApprove] = useState(false);
  const isNoteMode = useSelector(selectIsNotMode);
  const isCommentMode = useSelector(selectCommentData);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [loading, setLoading] = useState(true);
  const [showChecklist, setShowChecklist] = useState(false);
  const [showCommentEdit, setShowCommentEdit] = useState(false);

  const [commentsData, setCommentsData] = useState([]);
  const navigate = useNavigate();
  const [approvedimage] = useState(1);
  const [approvedwithcomments] = useState(3);
  const [showbutton, setShowbutton] = useState(false);

  const handleZoomIn = () => {
    setZoomLevel((prev) => Math.min(prev + 0.1, 3));
  };

  const handleZoomOut = () => {
    setZoomLevel((prev) => Math.max(prev - 0.1, 0.5));
  };

  const GetcommentByImageId = async (imageid, proofId, versionNo) => {
    setLoading(true);
    try {
      const response = await get(
        `${urls.getcommentByImageid}?imageId=${imageid}&proofId=${proofId}&versionId=${versionNo}`,
      );
      const responseData = response?.data;
      if (responseData.length < 1) {
        setShowApprove(true);
      }
      if (responseData) {
        setShowCommentEdit(responseData.ProofWorkflowContactId == workflowContactId);

        setCommentsData(responseData);
        console.log('Fetched comments data:', responseData);
      } else {
        console.error('API call unsuccessful:', responseData?.message);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    dispatch(clearNotes());

    if (!imageData?.ImageId) {
      setLoading(false);
      return;
    }

    setShowbutton(imageData?.ContactType == 1 ? true : false);

    setCommentsData([]);
    setLoading(true);

    GetcommentByImageId(imageData?.ImageId, imageData?.ProofId, imageData?.VersionNo);
    if (!isNoteMode) {
      dispatch(clearNotes());
      dispatch(toggleNoteMode());
    }
  }, [imageData?.ImageId]);

  useEffect(() => {
    if (isNoteMode && commentsData.length > 0) {
      dispatch(clearNotes());
      commentsData.forEach((comment, index) => {
        const coords = {
          x: { size: comment.x, unit: 'vw' },
          y: { size: comment.y, unit: 'vh' },
        };

        const text = comment.comments?.[0]?.description || '';
        const noteId = comment.commentBlockId;
        const targetSelector = '.ant-spin-container';

        dispatch(addNote({ coords, targetSelector, text, noteId }));

        if (index === 0) {
          dispatch(setActiveEntityId(noteId));
        }
      });
    }
  }, [isNoteMode, commentsData, imageData?.ImageId]);

  useEffect(() => {
    GetcommentByImageId(imageData?.ImageId, imageData?.ProofId, imageData?.VersionNo);
  }, [isCommentMode]);

  if (!imageData?.ImageURL) {
    return <div>No image provided.</div>;
  }

  const handleApprove = () => {
    updateClassApproval(approvedimage);
  };
  const handleApprovewithcomments = () => {
    updateClassApproval(approvedwithcomments);
  };

  const updateClassApproval = async (isapproved) => {
    try {
      setLoading(true);
      const payload = {
        versionmapingImageId: imageData?.VersionmapingImageId,
        versionNo: imageData?.VersionNo,
        isApproved: isapproved,
        proofId: imageData?.ProofId,
        proofWorkflowContactId: workflowContactId,
      };

      const result = await post(urls.updateClassApproval, payload);

      if (result.flag) {
        navigate(`/admin/ReviewProof/?ProofId=${imageData?.ProofId}`);
        showNotification(MessageType.Success, result.message);
      } else {
        showNotification(MessageType.Error, result.message);
      }
    } catch (errorInfo) {
      showNotification(MessageType.CatchError, '');
    }
    setLoading(false);
  };

  return (
    <>
      <PageHeader
        title="Review Proof Image"
        buttons={[
          <div className="page-header-actions">
            <Button
              size="small"
              className="btn-add_new"
              type="secondary"
              onClick={() => {
                const targetUrl = isFromProofPage
                  ? `/admin/proofs/view-proof/${proofId}`
                  : `/admin/ReviewProof/?ProofId=${imageData?.ProofId}`;

                navigate(targetUrl, {
                  state: {
                    tabKey: 4,
                  },
                });
              }}
            >
              <RollbackOutlined />
              Back
            </Button>
          </div>,
        ]}
      />

      <Main>
        <Checklist
          open={showChecklist}
          onContinue={() => handleApprove()}
          buttonLabel="Accept & Continue"
          onClose={() => setShowChecklist(false)}
        />
        <Row gutter={15}>
          <Col xs={24}>
            {/* <Spin spinning={loading}> */}
            <Cards headless>
              <DataTableStyleWrap>
                <div className="ninjadash-datatable-filter">
                  <div className="ninjadash-datatable-filter__left page-header-actions custom-get-review-image-header">
                    <div className="mode-switch">
                      <label htmlFor="note-mode">Comments</label>
                      {/* <Switch.Root
                        checked={isNoteMode}
                        onClick={() => dispatch(toggleNoteMode())}
                        className="toggle"
                        id="note-mode"
                      >
                        <Switch.Thumb className="switch-thumb" />
                      </Switch.Root> */}

                      <Segmented
                        value={isNoteMode ? 'Show' : 'Hide'}
                        options={['Hide', 'Show']}
                        onChange={(val) => dispatch(toggleNoteMode(val === 'Show'))}
                        style={{
                          marginBottom: 8,
                        }}
                      />
                    </div>
                    <Button
                      size="small"
                      // data-zoom-button
                      onClick={handleZoomOut}
                      className="btn-add_new zoom-button"
                      type="secondary"
                    >
                      <AiOutlineZoomOut />
                      Zoom Out
                    </Button>
                    <Button
                      size="small"
                      // data-zoom-button
                      onClick={handleZoomIn}
                      className="btn-add_new zoom-button"
                      type="secondary"
                    >
                      <AiOutlineZoomIn />
                      Zoom In
                    </Button>
                  </div>

                  {imageData?.IsApproved === 2 && showbutton == true && (
                    <div
                      style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginBottom: '20px' }}
                      hidden={isFromProofPage}
                    >
                      {!showApprove ? (
                        <Tooltip placement="top" title="Cannot approve with pending comments">
                          <Button className="btn-add_new zoom-button" type="primary" disabled>
                            Approve
                          </Button>
                        </Tooltip>
                      ) : (
                        <Button
                          className="btn-add_new zoom-button"
                          type="primary"
                          disabled={imageData?.IsApproved !== approvalEnums.Pending}
                          onClick={() => {
                            setShowChecklist(true);
                          }}
                        >
                          Approve
                        </Button>
                      )}
                      <Button
                        className="btn-add_new zoom-button"
                        disabled={imageData?.IsApproved !== approvalEnums.Pending}
                        type="primary"
                        onClick={() => {
                          handleApprovewithcomments();
                        }}
                      >
                        Approve with Comments
                      </Button>
                    </div>
                  )}
                </div>
              </DataTableStyleWrap>

              <div className="custom-get-review-image">
                {/* <header className="custom-get-review-image-header flex justify-between align-center">
                  <div className="mode-switch">
                    <label htmlFor="note-mode">Note Mode</label>
                    <Switch.Root
                      checked={isNoteMode}
                      onClick={() => dispatch(toggleNoteMode())}
                      className="toggle"
                      id="note-mode"
                    >
                      <Switch.Thumb className="switch-thumb" />
                    </Switch.Root>
                  </div>
                  <div className="zoom-controls">
                    <button data-zoom-button onClick={handleZoomOut}>
                      <AiOutlineZoomOut />
                      Zoom Out
                    </button>
                    <button data-zoom-button onClick={handleZoomIn}>
                      <AiOutlineZoomIn />
                      Zoom In
                    </button>
                  </div>
                </header> */}

                <div className="notes-container" style={{ display: 'flex', width: '100%', gap: '2rem' }}>
                  <div className="wrapper">
                    <div
                      className="zoom-container"
                      style={{
                        transform: `scale(${zoomLevel})`,
                        transformOrigin: 'top left',
                      }}
                    >
                      <div className="hero">
                        <Spin spinning={loading}>
                          <img
                            src={imageData?.ImageURL}
                            alt="Review"
                            onLoad={() => setLoading(false)}
                            onError={() => setLoading(false)}
                          />
                        </Spin>
                      </div>
                    </div>
                  </div>

                  <ActivityContents className="comment-section">
                    <Cards headless>
                      {(commentsData || [])
                        .flatMap((block) => block?.comments)
                        .sort((a, b) => new Date(b?.createdDateTime) - new Date(a?.createdDateTime))
                        .map((block) => {
                          // const sortedComments = [...(block.comments || [])].sort(
                          //   (a, b) => new Date(b?.createdDateTime) - new Date(a?.createdDateTime),
                          // );

                          return (
                            <ul className="activity-list" key={`block-${block?.commentId}`}>
                              {/* {sortedComments.map((comment) => ( */}
                              <li className="activity-list__single" key={`comment-${block?.commentId}`}>
                                <span className="activity-icon primary">
                                  <UilCommentAlt />
                                </span>
                                <div className="activity-content">
                                  <div className="activity-info">
                                    <img src={require('../../static/img/No_image_available.png')} alt="user" />
                                    <p>
                                      <span className="inline-text color-primary">{block?.createdBy}</span>{' '}
                                      {moment(block?.createdDateTime).format('MM/DD/YYYY')}
                                      <br />
                                      <span className="hour">{block?.description}</span>
                                    </p>
                                  </div>
                                </div>
                              </li>
                              {/* ))} */}
                            </ul>
                          );
                        })}
                    </Cards>
                  </ActivityContents>
                </div>
              </div>
            </Cards>
            {/* </Spin> */}
          </Col>
        </Row>
      </Main>
      <Page setCommentsData={commentsData} showEdit={showCommentEdit} workflowContactId={workflowContactId} />
    </>
  );
};

export default GetReviewImage;
